import React, { useCallback, useEffect, useState } from 'react'
import Image from 'next/legacy/image'
import styled from 'styled-components'
import { Card } from 'components/common/card'
import { BoldText } from 'components/common/text'
import { theme } from 'infra/theme'
import { useIsDesktop } from 'utils/hooks'
import { IS_BROWSER } from 'infra/constants'

const EMPLOYMENT_REWARD_NOTICE_KEY = 'employment_reward_notice_closed'

export const EmploymentRewardNotice: React.FC = () => {
  const isDesktop = useIsDesktop()
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    if (IS_BROWSER) {
      const closed = sessionStorage.getItem(EMPLOYMENT_REWARD_NOTICE_KEY)
      if (closed === 'true') setVisible(false)
    }
  }, [])

  const handleClose = useCallback((e: React.MouseEvent) => {
    e.stopPropagation()
    if (IS_BROWSER) {
      sessionStorage.setItem(EMPLOYMENT_REWARD_NOTICE_KEY, 'true')
    }
    setVisible(false)
  }, [])

  const handleClick = useCallback(() => {
    window.open('https://tally.so/r/3jxKk4', '_blank')
  }, [])

  if (!visible) return null

  return (
    <StyledCard onClick={handleClick}>
      <CloseButton onClick={handleClose}>
        <Image src='/x-circle.svg' width={18} height={18} alt='x' />
      </CloseButton>
      {isDesktop ? (
        <>
          <NoticeText>
            ✨ 그룹바이로 만난 기업에 합격되면{' '}
            <b style={{ color: theme.color.primary }}>취업축하금 30만원</b>을
            드려요!
          </NoticeText>
          <NoticeText style={{ textDecoration: 'underline' }}>
            취업축하금 신청하기
          </NoticeText>
        </>
      ) : (
        <NoticeText>그룹바이로 합격되면 취업축하금 30만원을 드려요!</NoticeText>
      )}
    </StyledCard>
  )
}

const StyledCard = styled(Card)`
  gap: 60px;
  position: relative;
  flex-direction: row;
  justify-content: space-between;
  padding: 8px 16px;
  border: 1px solid ${(p) => p.theme.color.line};
  cursor: pointer;
  align-items: center;
`

const CloseButton = styled.div`
  position: absolute;
  top: -6px;
  right: -6px;
  cursor: pointer;
  z-index: 2;
`

const NoticeText = styled(BoldText)`
  color: ${(p) => p.theme.color.black3};
  font-size: 14px;
  @media ${(p) => p.theme.deviceSize.mobile} {
    font-size: 12px;
  }
`
